import { NavLink, Outlet, Route, useLocation } from "react-router";
import Layout from "../components/Layout";
import useLivlyUser from "../context/UserProvider";
import { BuildingServiceType, ServiceTypeEnum } from "@/types/Building";
import classNames from "classnames";

function FeedbackPage() {
  const { user } = useLivlyUser();
  let location = useLocation() as { state: { background: string } };
  let background = location.state && location.state.background;
  const { pollsEnabled, feedbackEnabled, surveyEnabled } = getIsFeedbackTabsVisible(
    user.building.serviceTypes ?? []
  );
  const isFeedbackTabsVisible = pollsEnabled || feedbackEnabled || surveyEnabled;

  return (
    <Layout title="My Feedback">
      {isFeedbackTabsVisible && (
        <div className="flex text-sm">
          {surveyEnabled && (
            <NavLink
              to="surveys"
              end
              className={({ isActive }) =>
                classNames(
                  "px-3 py-2 flex-1 text-center sm:flex-none sm:text-left",
                  {
                    "rounded-full bg-[#FAEDE4]": isActive,
                  }
                )
              }
            >
              Surveys
            </NavLink>
          )}
          {feedbackEnabled && (
            <NavLink
              to="reviews"
              end
              className={({ isActive }) =>
                classNames(
                  "px-3 py-2 flex-1 text-center sm:flex-none sm:text-left",
                  {
                    "rounded-full bg-[#FAEDE4]": isActive,
                  }
                )
              }
            >
              Reviews and Feedback
            </NavLink>
          )}
          {pollsEnabled && (
            <NavLink
              to="polls"
              className={({ isActive }) =>
                classNames(
                  "px-3 py-2 flex-1 text-center sm:flex-none sm:text-left",
                  {
                    "rounded-full bg-[#FAEDE4]": isActive,
                  }
                )
              }
            >
              Polls
            </NavLink>
          )}
        </div>
      )}
      <Outlet />
    </Layout>
  );
}

export { FeedbackPage };

export function getIsFeedbackTabsVisible(serviceTypes: BuildingServiceType[]) {
  const residentFeedbackService = serviceTypes.find(
    (st) => st.serviceType === ServiceTypeEnum.ResidentFeedback
  );

  const residentPolls = serviceTypes.find(
    (st) => st.serviceType === ServiceTypeEnum.ResidentPolls
  );

  const communitySurveyService = serviceTypes.find(
    (st) => st.serviceType === ServiceTypeEnum.Surveys
  );

  const moveInSurveyService = serviceTypes.find(
    (st) => st.serviceType === ServiceTypeEnum.ScheduleMoveIn
  );

  return {
    pollsEnabled: residentPolls?.enabled ?? false,

    feedbackEnabled: residentFeedbackService?.enabled ?? false,

    surveyEnabled:
      (communitySurveyService?.enabled ?? false) ||
      (moveInSurveyService?.enabled ?? false),
  };
}
